import { RECAPTCHA_SITE_KEY, RecaptchaLoaderService } from './services/recaptcha.service'
import { recaptchaInterceptor } from './interceptors/recaptcha.interceptor'
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { inject, LOCALE_ID, NgModule, provideAppInitializer } from '@angular/core'
import { registerLocaleData } from '@angular/common'
import localePt from '@angular/common/locales/pt'
import { tenantInterceptor } from './interceptors/tenant.interceptor'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { TenantConfigService } from './services/tenant.service'
import { AuthService } from './services/auth.service'
import { BrowserModule } from '@angular/platform-browser'
import { AppRoutingModule } from './app-routing.module'
import { RUNTIME_CONFIG } from '@config/runtime-config'
import { AppComponent } from './app.component'

registerLocaleData(localePt, 'pt-BR')

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        FormsModule,
        BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule
    ],
    providers: [
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        { provide: RECAPTCHA_SITE_KEY, useFactory: () => inject(RUNTIME_CONFIG).recaptcha_key },
        provideAppInitializer(() => inject(TenantConfigService).load()),
        provideAppInitializer(() => inject(RecaptchaLoaderService).init()),
        provideAppInitializer(() => inject(AuthService).bootstrapSession()),
        provideHttpClient(withInterceptors([tenantInterceptor, recaptchaInterceptor]))
    ],
    exports: [],
    bootstrap: [AppComponent]
})
export class AppModule {
}
